import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { scrollToElement } from '@sparefoot/react-core/utils/scrolling';
import { H3 } from 'components/core/Typography';
import { Button } from 'components/core/Button';
import { Modal, ModalBody, ModalTitle, ModalFooter } from 'components/core/Modal';
import { FiltersList } from 'components/search/SearchFilters';

import './SearchFiltersModal.scss';

export function SearchFiltersModal({
	showing, onClose, segmentLabel, title,
	onFilter, searchParams, searchType, storageTypeUrls
}) {
	const [storageType, setStorageType] = useState(searchType);

	// when we change the storage type, update the search type in search params
	// so when the user actually applies the filters, it does the correct search type.

	React.useEffect(() => {
		// note we're delaying filtering here
		onFilter({ type: storageType }, true);
	}, [storageType]);

	// store these for consistency w/ the tabs/button
	// and so we can use state to pick the correct one for the button
	const storageTypeNames = { storage: 'Self-Storage', vehicle: 'Vehicle Storage' };


	const handleApplyButtonClick = () => {
		onFilter();
		scrollToElement('.search-summary');
		onClose();
	};

	return (
		<Modal
			className="search-filters-modal"
			segmentLabel={segmentLabel}
			segmentCategory="search modal"
			showing={showing}
			onClose={onClose}
			hasDarkTitleBackground
		>
			<ModalTitle bgColor="navyBlue">
				<H3 last size="medium" color="white">
					{title}
				</H3>
			</ModalTitle>
			<ModalBody noPadding>
				<div className="filter-tabs">
					<Button
						segmentLabel="self-storage filters tab"
						type="button"
						className={classnames('filter-tab', { selected: storageType === 'storage' })}
						onClick={() => setStorageType('storage')}
					>
						{`${storageTypeNames.storage} Filters`}
					</Button>
					<Button
						segmentLabel="vehicle storage filters tab"
						type="button"
						className={classnames('filter-tab', { selected: storageType === 'vehicle' })}
						onClick={() => setStorageType('vehicle')}
					>
						{`${storageTypeNames.vehicle} Filters`}
					</Button>
				</div>
				<FiltersList
					listKey="search-modal-filters"
					showing={showing}
					onClose={onClose}
					onFilter={onFilter}
					delayFiltering
					searchParams={searchParams}
					searchType={storageType}
					storageTypeUrls={storageTypeUrls}
				/>
			</ModalBody>
			<ModalFooter bgColor="navyBlue">
				<Button
					segmentLabel={`apply ${storageTypeNames[storageType]} filters button`}
					onClick={handleApplyButtonClick}
					primary
					fullWidth
				>
					{`Apply ${storageTypeNames[storageType]} Filters`}
				</Button>
			</ModalFooter>
		</Modal>
	);
}

SearchFiltersModal.propTypes = {
	showing: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	segmentLabel: PropTypes.string,
	title: PropTypes.string,
	onFilter: PropTypes.func.isRequired,
	searchParams: PropTypes.object.isRequired,
	searchType: PropTypes.string,
	storageTypeUrls: PropTypes.object
};

export default SearchFiltersModal;
